// extracted by mini-css-extract-plugin
module.exports = {"scroller":"scroller-module__scroller___ewlbN","scrollIcon":"scroller-module__scrollIcon___Zr+9p","similarPropIcon":"scroller-module__similarPropIcon___jMozg"};